import { render } from "./PatientActivityLevelEdit.vue?vue&type=template&id=0a8977e2&scoped=true"
import script from "./PatientActivityLevelEdit.vue?vue&type=script&lang=js"
export * from "./PatientActivityLevelEdit.vue?vue&type=script&lang=js"

import "./PatientActivityLevelEdit.vue?vue&type=style&index=0&id=0a8977e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8977e2"]])

export default __exports__